<form [formGroup]="form" (submit)="submitForm()">
  <mat-card class="p-4 w-7 mx-auto bg-grey-button form-award-acceptance">
    <div class="edit-field my-1">
      <label for="studentName">Student Name</label>
      <input
        id="studentName"
        matInput
        formControlName="studentName"
        [value]="context.studentName ?? ''"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_student_name_input"
        data-qa="edit_student_name_input" />
    </div>

    <div class="edit-field my-1">
      <label for="awardAmount">Award Amount</label>
      <input
        id="awardAmount"
        matInput
        formControlName="awardAmount"
        [value]="context.awardAmount ?? ''"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_award_amount_input"
        data-qa="edit_award_amount_input" />
    </div>

    <div class="edit-field my-1">
      <label for="programTypeCode">Program</label>
      <input
        id="programTypeCode"
        matInput
        formControlName="programTypeCode"
        [value]="context.programTypeCode ?? ''"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_program_type_code_input"
        data-qa="edit_program_type_code_input" />
    </div>

    <div class="form-award-acceptance__decision my-3">
      <label for="isAwardAcceptedRadioGroup">
        Would you like to accept the {{ context.programTypeCode }} award?
        <span class="form-award-acceptance__required" aria-hidden="true">*</span>
      </label>
      <mat-radio-group
        id="isAwardAcceptedRadioGroup"
        aria-label="Would you like to accept the {{ context.programTypeCode }} award?"
        aria-required="true"
        formControlName="isAwardAccepted"
        class="form-award-acceptance__radio-group"
        data-pw="radio_is_award_accepted"
        data-qa="radio_is_award_accepted">
        <mat-radio-button [value]="true" data-pw="radio_is_award_accepted_yes" data-qa="radio_is_award_accepted_yes">
          Yes
        </mat-radio-button>
        <mat-radio-button [value]="false" data-pw="radio_is_award_accepted_no" data-qa="radio_is_award_accepted_no">
          No
        </mat-radio-button>
      </mat-radio-group>
      @if (form.value.isAwardAccepted === null) {
        <span
          class="form-award-acceptance__error"
          role="alert"
          data-pw="error_is_award_accepted_required"
          data-qa="error_is_award_accepted_required">
          Please indicate your decision to continue.
        </span>
      }
    </div>

    @if (!form.disabled) {
      <div class="button-row">
        <button
          aria-labelledby="Go Back Action"
          color="primary"
          data-qa="cancel_button"
          data-pw="cancel_button"
          mat-stroked-button
          tabindex="0"
          (click)="onBack()"
          (keyup)="($event.key === 'Enter' || $event.key === ' ') && onBack()">
          Cancel
        </button>
        <button
          mat-flat-button
          type="submit"
          [disabled]="!isFormReady()"
          color="primary"
          data-pw="submit_button"
          data-qa="submit_button">
          Submit
        </button>
      </div>
    }
  </mat-card>
</form>
